import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';
import { ThemeToggle } from '../../app/theme';

interface LandingNavProps {
  onScrollTo: (sectionId: string) => void;
}

export function LandingNav({ onScrollTo }: LandingNavProps) {
  return (
    <header className="sticky top-0 z-50 border-b border-[color:var(--color-line)] bg-[color:var(--color-surface)] backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex min-h-[4.75rem] flex-wrap items-center justify-between gap-4 py-3">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[linear-gradient(135deg,var(--color-brand),var(--color-brand-strong))] text-[color:var(--color-on-brand)] shadow-[0_16px_32px_rgba(var(--color-brand-rgb),0.22)]">
              <Activity className="w-6 h-6" />
            </div>
            <div className="leading-none">
              <p className="text-[0.68rem] font-extrabold uppercase tracking-[0.28em] text-[var(--color-muted)]">
                Coaching Studio
              </p>
              <span className="mt-1 block text-xl font-extrabold text-[var(--color-ink)]">TrackWithAI</span>
            </div>
          </div>

          <nav className="hidden items-center gap-2 md:flex">
            <button
              onClick={() => onScrollTo('features')}
              className="pill-nav px-4 py-2"
            >
              What You Can Do
            </button>
            <button
              onClick={() => onScrollTo('how-it-works')}
              className="pill-nav px-4 py-2"
            >
              Week to Week
            </button>
            <button
              onClick={() => onScrollTo('pricing')}
              className="pill-nav px-4 py-2"
            >
              Pricing
            </button>
            <Link to="/coaches" className="pill-nav px-4 py-2">
              For Coaches
            </Link>
          </nav>

          <div className="flex items-center gap-3">
            <ThemeToggle />
            <Link
              to="/login"
              className="pill-nav px-4 py-2"
            >
              Sign In
            </Link>
            <Link
              to="/start"
              className="app-button app-button--primary px-4 py-2 text-sm"
            >
              Try The Coach
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
